import { render, staticRenderFns } from "./eulogyDetail.vue?vue&type=template&id=2a7cf14a&scoped=true"
import script from "./eulogyDetail.vue?vue&type=script&lang=js"
export * from "./eulogyDetail.vue?vue&type=script&lang=js"
import style0 from "./eulogyDetail.vue?vue&type=style&index=0&id=2a7cf14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7cf14a",
  null
  
)

export default component.exports